import {
  TableData,
  TableHeaderCategoryConfig,
} from "../../../../../components/tables/tableContext/TableContext";
import { CustomerNotificationsDataInterface } from "../../../../../redux/interfaces/admin.interface";

export const customerNotificationsTableHeader: TableHeaderCategoryConfig[] = [
  {
    label: "",
    value: "selected",
    minW: 125,
  },
  {
    label: "Client",
    value: "client",
    minW: 125,
  },
  {
    label: "Adresa",
    value: "adresa",
    withSearch: true,
    minW: 125,
  },
  {
    label: "Notificari",
    value: "acces_notificari",
    minW: 125,
  },
];

export const getCustomerNotificationsTableData = (
  data: CustomerNotificationsDataInterface[],
): TableData[] =>
  data.map((item) => {
    return {
      id: item.id_notificare_client,
      crudData: item,
      data: [
        {
          checkbox: {
            id: item.id_notificare_client,
            isSelected: false,
          },
        },
        {
          title: item.client,
        },
        {
          title: `${item.adresa}`,
          subtitle: `${item.localitate}, ${item.judet}, ${item.cod_postal}`,
        },
        {
          badges: [
            {
              badgeText: item.acces_notificari ? "Activ" : "Inactiv",
              badgeColor: item.acces_notificari
                ? "light-success"
                : "light-danger",
            },
          ],
        },
      ],
    };
  });
